export const returnIsFirefoxOrSafari = () => {
  if (navigator) {
    const isFirefoxOrSafari =
      navigator.userAgent.toLowerCase().includes('firefox') ||
      (navigator.userAgent.toLowerCase().includes('safari') &&
        !navigator.userAgent.toLowerCase().includes('chrome'));

    return isFirefoxOrSafari;
  } else {
    return false;
  }
};
